import React, { useState, useEffect } from 'react';

import PageLoader from 'ui/PageLoader';

import GroupsForm from './GroupsForm';
import { loadGroup, loadCompanies, loadCompany } from './services';

export default function GroupCreate({ match, history, updateBreadcrumbs }) {
    const { id, company_id: companyId } = match.params;
    const [group, setGroup] = useState(null);
    const [companies, setCompanies] = useState([]);

    useEffect(() => {
        loadCompany(companyId).then(company =>
            updateBreadcrumbs([
                { name: 'Companies', path: '/companies' },
                {
                    name: company.business_name,
                    path: `/companies/${companyId}`,
                },
                'View Company Group',
            ])
        );
        loadGroup(id, companyId).then(setGroup);
        loadCompanies(companyId).then(setCompanies);
    }, []);

    const handleSave = async data => {};
    const handleCancel = () =>
        history.push(`/companies/${companyId}/partner/company_groups`);

    if (!group) {
        return <PageLoader />;
    }
    return (
        <GroupsForm
            mode="view"
            group={group}
            companies={companies}
            onSave={handleSave}
            onCancel={handleCancel}
        />
    );
}
